<template>
    <div class="about-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">About Us</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="about-body">
                <div class="about-title">Vindome</div>
                <div class="about-separator"></div>
                <div class="about-text">Vindome is a dynamic online wine trading platform for investors, collectors and fine wine enthusiasts, bringing together the latest technology and world class wine expertise.<br><br>Vindome's founding team combines development and investment expertise not only in wine but also wube trading, tech start-ups, and in growing global trading companies.</div>

                <div class="about-title">Meet the team</div>
                <div class="about-separator"></div>
                <div class="team-wrapper">
                    <div class="team-item team-item1 team-item-margin">
                        <div class="team-item-img"></div>
                        <div class="team-item-name">Victoria Palatnik</div>
                        <div class="team-item-pos">Founder</div>
                        <div class="team-item-desc">It is largely thanks to Victoria's wealth of knowledge and business acumen that Vindome has been transformed from a concept to reality. A vastly experienced technology enterpreneur, operating executive and venture capitalist, Victoria has a proven track record in launching successful businesses.</div>
                    </div>
                    <div class="team-item team-item3 team-item-margin">
                        <div class="team-item-img"></div>
                        <div class="team-item-name">Ingrid Brodin</div>
                        <div class="team-item-pos">CEO</div>
                        <div class="team-item-desc">Ingrid is a start-up entrepreneur with over 20 years' experience developing and growing international businesses both in Europe and emerging markets. Ingrid has the background and vision to revolutionise the way fine wine is traded and is the driving force behind Vindome.</div>
                    </div>
                    <div class="team-item team-item4">
                        <div class="team-item-img"></div>
                        <div class="team-item-name">Roderick Smith MW</div>
                        <div class="team-item-pos">Master of Wine</div>
                        <div class="team-item-desc">After many years in wine sales, Rod is now a successful wine consultant based in the South of France. One of only 390 Masters of Wine in the world, and a renowned wine adviser writer, educator and public speaker, Rod has advised on the prestigious selection of wines available through Vindome.</div>
                    </div>
                    <div class="team-item team-item5 team-item-margin">
                        <div class="team-item-img"></div>
                        <div class="team-item-name">Mario Colesanti</div>
                        <div class="team-item-pos">Head of Sales & Marketing</div>
                        <div class="team-item-desc">25 years experience of leading sales and marketing organisations in the luxury goods industry. Mario has a history of successfully bringing new products to the market by leveraging on integrated marketing plans and strong brand strategies.</div>
                    </div>
                    <div class="team-item team-item6">
                        <div class="team-item-img"></div>
                        <div class="team-item-name">Vesela Kichukova</div>
                        <div class="team-item-pos">Head of Development</div>
                        <div class="team-item-desc">More than 20 years experience in software development and project management. Vesela has successfully driven global software development projects in telecommunications and trading platforms used by millions of customers.</div>
                    </div>
                    <!--<div class="team-item team-item7 team-item-margin">-->
                        <!--<div class="team-item-img"></div>-->
                        <!--<div class="team-item-name">Simona Veziano</div>-->
                        <!--<div class="team-item-pos">Admin / Customer Service</div>-->
                        <!--<div class="team-item-desc">Simona runs the Vindome office day to day, providing customer service support and is a wine enthusiast. She has the experience and breadth of knowledge to help answer any customer queries.</div>-->
                    <!--</div>-->
                </div>
                <img class="worldmap" src="../assets/about/europe_map.png"/>
                <div class="location-wrapper">
                    <div class="location-item team-item-margin">
                        <div class="location-title">London</div>
                        <div class="location-desc">Fairgate House 78 New Oxford Street, WC1A 1HB, London</div>
                    </div>
                    <div class="location-item team-item-margin">
                        <div class="location-title">Monaco</div>
                        <div class="location-desc">Villa Mignon, 1 rue Suffren Reymond, 98000, Monaco</div>
                    </div>
                    <div class="location-item">
                        <div class="location-title">Sofia</div>
                        <div class="location-desc">15 Tintyava Str, NPZ Dianabad, 1113, Sofia</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "About",
        head: {
            title: 'About us | Fine Wine Trading App',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
                }
            ],
            bodyAttrs: {
                class: 'page-aboutus inner-page'
            }
        }
    }
</script>

<style scoped>
    .about-container {
        background: #ffffff;
    }
    .container {
        max-width: 1170px;
        padding: 0;
        font-family: 'Poppins', sans-serif;
    }
    .about-body {
        padding-top: 30px;
        font-size: 16px;
        font-weight: 400;
    }
    .about-title {
        margin-top: 31px;
        font-size: 38px;
        line-height: 24px;
        font-weight: 700;
        color: #024E7B;
    }

    .about-separator {
        width: 50px;
        height: 3px;
        background-color: #E5C57B;
        margin: 40px 0;
    }
    .about-text {
        margin-bottom: 80px;
    }
    .team-item {
        background-color: #F8F0DE;
        padding: 100px 30px 30px;
        position: relative;
        display: inline-block;
        height: 410px;
        width: calc((100% - 60px)/3);
        margin-top: 100px;
        vertical-align: top;
    }
    .team-item-margin {
        margin-right: 30px;
    }
    .team-item-img {
        position: absolute;
        margin: 0 auto;
        left: 0;
        right: 0;
        top: -75px;
        border-radius: 50%;
        width: 150px;
        height: 150px;
    }
    .team-item1 .team-item-img {
        background: url('../assets/about/victoria.png') no-repeat center;
    }
    .team-item2 .team-item-img {
        background: url('../assets/about/denis.png') no-repeat center;
    }
    .team-item3 .team-item-img {
        background: url('../assets/about/ingrid.png') no-repeat center;
    }
    .team-item4 .team-item-img {
        background: url('../assets/about/rod.png') no-repeat center;
    }
    .team-item5 .team-item-img {
        background: url('../assets/marioi.png') no-repeat center;
    }
    .team-item6 .team-item-img {
        background: url('../assets/vesela.png') no-repeat center;
    }
    .team-item7 .team-item-img {
        background: #024E7B;
    }
    .team-item-name {
        text-align: center;
        font-family: 'Poppins', sans-serif;
        font-weight: 500;
        color: #024E7B;
        line-height: 33px;
        font-size: 20px;
    }
    .team-item-pos {
        text-align: center;
        font-family: 'Poppins', sans-serif;
        font-size: 16px;
        line-height: 33px;
        color: #000000;
        margin-bottom: 10px;
    }
    .team-item-desc {
        font-family: 'Poppins', sans-serif;
        font-size: 16px;
        text-align: justify;
        color: #636059;
        line-height: 24px;
    }
    .worldmap {
        margin: 150px 0 80px;
    }
    .location-item {
        position: relative;
        display: inline-block;
        height: 185px;
        width: calc((100% - 60px)/3);
        vertical-align: top;
        background: url('../assets/about/address_icon.png') no-repeat 10px 44px;
        padding: 30px 15px 30px 60px;
    }
    .location-title {
        text-align: left;
        font-family: 'Poppins', sans-serif;
        font-weight: 500;
        color: #013D61;
        line-height: 48px;
        font-size: 20px;
    }

    @media (width: 1024px) {
        .about-body {
            padding-left: 30px;
            padding-right: 30px;
        }
        .worldmap {
            width: 100%;
        }
        .team-item {
            height: 520px;
        }
    }

    @media (max-width: 767px) {
        .about-body {
            padding-left: 15px;
            padding-right: 15px;
        }
        .about-title {
            margin-top: 0;
            font-size: 25px;
        }
        .about-separator {
            margin: 20px 0;
        }
        .about-text {
            margin-bottom: 30px;
        }
        .team-item {
            width: 100%;
            margin: 100px 0 30px 0;
            height: auto;
        }
        .worldmap {
            display: none;
        }
        .location-item {
            width: 100%;
        }
    }
</style>
<style>
    .page-aboutus .header-toolbar {
        box-shadow: none;
    }
</style>
